import React, { useCallback } from "react";
import PropTypes from "prop-types";
import * as R from "ramda";

import { useCurrentTenant } from "contexts/currentTenant";
import { useCurrentGuide } from "queries/guides";
import { getUseCodeFilters } from "reducers/guides";
import { getUseCodes } from "reducers/tenant";
import filterUseCodes from "utils/filterUseCodes";

import { RadioButtonOption } from "./RadioButtonField";
import { immediateInput } from "./behaviors";

// TODO: Why is this it's own component, but not an actual ui type?
// it's rendered directly from BuildingTypePage
const BuildingTypeField = ({ value, field, onChange, onSave }) => {
  const { data: guide } = useCurrentGuide();
  const tenant = useCurrentTenant();
  const useCodeFilter = guide ? getUseCodeFilters(guide) : [];

  const allUseCodes = getUseCodes(tenant);
  let filteredUseCodes = R.filter(R.propEq(true, "featured"), allUseCodes);
  if (useCodeFilter.length > 0) {
    filteredUseCodes = filterUseCodes(filteredUseCodes, useCodeFilter).sort((a, b) =>
      (a.icon_label || a.name).localeCompare(b.icon_label || b.name),
    );
  }
  const onChangeUseCode = useCallback(
    (selectedValue) => {
      const useCode = R.find(R.propEq(selectedValue, "slug"), filteredUseCodes);
      return onChange({ use: useCode });
    },
    [filteredUseCodes, onChange],
  );

  return (
    <BuildingTypeOptions
      value={value}
      field={field}
      onChange={onChangeUseCode}
      onSave={onSave}
      useCodes={filteredUseCodes}
    />
  );
};

// HACK - this lets us replace use featured + attached icon and thus paperclip.
// this should work like special event types on config side in future
function guessIconKey(label) {
  const l = label.toLowerCase();

  if (l.match(/mobile/) || l.match(/manufacture/)) return "mobile-home";
  if (l.match(/guest/) || l.match(/accessory/)) return "adu";
  if (l.match(/apartment/) || l.match(/multi/)) return "apartment";
  if (l.match(/three/) || l.match(/town/) || l.match(/triple/)) return "three-family-home";
  if (l.match(/two/) || l.match(/duplex/)) return "two-family-home";
  if (l.match(/single/) || l.match(/one/) || l.match(/group/)) return "single-family-home";

  return "other";
}

const BuildingTypeOptions = immediateInput(
  Object.assign(
    ({ value, field, onChange, useCodes }) => {
      const selectedValue = R.pathOr("", ["use", "slug"], value);

      return (
        <div data-building-type-field>
          {R.map(
            (u) => (
              <div data-use-code-results key={u.full_name}>
                <RadioButtonOption
                  fieldKey={field.key}
                  selectOption={{
                    ...u,
                    code: u.slug,
                    label: u.icon_label || u.name,
                    icon_key: guessIconKey(u.icon_label || u.name),
                  }}
                  selectedValue={selectedValue}
                  iconURL={u.icon_url}
                  onChange={onChange}
                  asHeading
                />
              </div>
            ),
            useCodes,
          )}
        </div>
      );
    },
    {
      displayName: "BuildingTypeOptions",
    },
  ),
);

BuildingTypeField.propTypes = {
  field: PropTypes.shape({
    key: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default BuildingTypeField;
